import { o_global } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
const events = o_global.events;
const eventQBus = o_global.eventQBus;
export {
  eventQBus,
  events
};
/*                                           */
